import { colors, sizing } from "@carrotfertility/carotene"
import React from "react"
import styled from "@emotion/styled"
interface RadioButtonProps extends React.ComponentPropsWithRef<"input"> {
  checked: boolean
}

const Radio = styled.input({
  cursor: "pointer",
  display: "none",
  "input:checked ~ &": {
    border: "none",
    position: "relative",
    display: "none"
  }
})
const Label = styled.label(
  {
    border: "2px solid",
    borderRadius: "28px;",
    cursor: "pointer",
    color: colors.base.black80,
    fontSize: sizing.font.medium,
    width: "auto",
    padding: "8px 16px 8px 16px",
    "&:hover": {
      border: "2px solid #e48400"
    }
  },
  ({ checked }: Pick<RadioButtonProps, "checked">) => ({
    display: "flex",
    alignItems: "center",
    background: checked ? colors.base.veryLightCarrotOrange : colors.base.white,
    borderColor: checked ? colors.base.carrotOrange : colors.base.black10
  })
)
export function RadioButton({ children, checked, ...props }: RadioButtonProps): JSX.Element {
  const onKeyPressEventPayload = { target: { value: props.value } } as React.ChangeEvent<HTMLInputElement>
  return (
    <Label
      role="radio"
      aria-checked={checked}
      onKeyDown={(event) => (event.keyCode === 32 || event.code === "Space") && props.onChange(onKeyPressEventPayload)}
      checked={checked}
      tabIndex={0}
    >
      <Radio type="radio" checked={checked} {...props} />
      {children}
    </Label>
  )
}
